'use client';

import React, { FC, useState } from 'react';

import { Image, Paper, PaperProps, ActionIcon, Modal } from '@mantine/core';
import { IoClose, IoExpandOutline } from 'react-icons/io5';

import classes from './ImageBlock.module.css';

const ImageBlock: FC<
    PaperProps & {
        image: {
            src: string;
            width: number;
            height: number;
        };
        maxWidth?: number | string;
    }
> = ({ image, radius = 'md', shadow = 'md', maxWidth, style, ...rest }) => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <Modal
                fullScreen
                opened={opened}
                onClose={() => setOpened(false)}
                padding={0}
                withCloseButton={false}
                classNames={{
                    body: classes.modalBody,
                }}
            >
                <ActionIcon
                    variant="white"
                    radius="xl"
                    size="lg"
                    onClick={() => setOpened(false)}
                    className={classes.closeButton}
                >
                    <IoClose size={18} />
                </ActionIcon>

                <Image src={image.src} fit="contain" className={classes.fullscreenImage} />
            </Modal>

            <Paper radius={radius} shadow={shadow} className={classes.paper} style={{ maxWidth, ...style }} {...rest}>
                <Image
                    className={classes.image}
                    src={image.src}
                    radius="md"
                    alt="nothing"
                    onClick={() => setOpened(true)}
                />
            </Paper>
        </>
    );
};

export { ImageBlock };
